import usePxAuthContext from 'src/authentication/usePxAuthContext';
import RoomsSocketContextProvider from 'src/contexts/RoomsSocketContextProvider';
import GameSocketContextProvider from 'src/contexts/GameSocketContextProvider';
import ArcwareContextProvider from 'src/features/Arcware/components/ArcwareContextProvider';
import useCurrentMetaverse from 'src/features/Dashboard/hooks/useCurrentMetaverse';
import InterlucentContextProvider from 'src/features/Interlucent/components/InterlucentContextProvider';
import SpsContextProvider from 'src/features/ScalablePixelStreaming/components/SpsContextProvider';
import UsageContextProvider from 'src/features/Usage/contexts/UsageContextProvider';

import Metaverse3DEditorArcwareSession from './Metaverse3DEditorArcwareSession';
import Metaverse3DEditorInterlucentSession from './Metaverse3DEditorInterlucentSession';
import Metaverse3DEditorSpsSession from './Metaverse3DEditorSpsSession';

export default function WrappedMetaverse3DEditorSession() {
  const { user, authToken } = usePxAuthContext();
  const { metaverse } = useCurrentMetaverse();
  const space = metaverse?.spaces[0];
  if (!user || !authToken || !metaverse || !space?.environment) return null;
  const {
    modelId,
    spsSignallingServerURL,
    shareId,
    provider,
  } = space.environment.purewebConfiguration;
  return (
    <RoomsSocketContextProvider
      userId={user._id}
      authToken={authToken}
      metaverseId={metaverse._id}
    >
      <GameSocketContextProvider
        authToken={authToken}
        metaverseId={metaverse._id}
      >
        <UsageContextProvider metaverseId={metaverse?._id}>
          {
            spsSignallingServerURL &&
            <SpsContextProvider signallingServerURL={spsSignallingServerURL}>
              <Metaverse3DEditorSpsSession metaverse={metaverse} space={space} />
            </SpsContextProvider>
          }
          {
            !spsSignallingServerURL && provider === 'interlucent' &&
            <InterlucentContextProvider appId={modelId}>
              <Metaverse3DEditorInterlucentSession metaverse={metaverse} space={space} />
            </InterlucentContextProvider>
          }
          {
            !spsSignallingServerURL && provider === 'arcware' && shareId &&
            <ArcwareContextProvider shareId={shareId} logo={metaverse?.logo}>
              <Metaverse3DEditorArcwareSession metaverse={metaverse} space={space} />
            </ArcwareContextProvider>
          }
        </UsageContextProvider>
      </GameSocketContextProvider>
    </RoomsSocketContextProvider>
  );
}
